import React from "react";
import { Tag, Tooltip } from "antd";
import { 
    ULD_CORE_STATUS_NAMES, 
    ULD_CORE_STATUS_COLORS 
} from "../constants/uldConstantsV3";

/**
 * ULD核心状态标签组件（V3模型）
 * 显示ULD的核心业务状态
 *
 * @param {Object} props 组件属性
 * @param {string} props.status ULD核心状态代码
 * @param {string} [props.description] 可选的状态描述信息
 * @param {Object} [props.style] 自定义样式
 */
const UldCoreStatusTag = ({ status, description, style }) => {
    // 获取状态名称和颜色
    const statusName = ULD_CORE_STATUS_NAMES[status] || status;
    const color = ULD_CORE_STATUS_COLORS[status] || "#999";

    // 带描述的Tag用Tooltip包装
    if (description) {
        return (
            <Tooltip title={description}>
                <Tag color={color} style={{ cursor: "pointer", ...style }}>
                    {statusName}
                </Tag>
            </Tooltip>
        );
    }

    // 无描述的简单Tag
    return (
        <Tag color={color} style={style}>
            {statusName}
        </Tag>
    );
};

export default UldCoreStatusTag; 